require('../core/grpn-lazyload');

module.exports = Groupon.Utils.lazyLoadImages = function(options, triggerClass) {
  var $el;
  if (triggerClass == null) {
    triggerClass = '.lazy-load';
  }
  if (($el = $(triggerClass)).length) {
    $el.lazyload(options);
  }
};

